import { Tooltip, Stack } from "@altimateai/lego";
import { CollapsibleField } from "@/components/text";
import { getNamedResourceImageByType } from "../../resourceTag/utils";
import { getResourceImageType } from "../../../utils";

interface GroupedDetailsCellProps {
  resource_type: number;
  opportunity_name: string;
  description?: string;
  occurrences: number;
}

export const GroupedDetailsCell = ({
  resource_type,
  opportunity_name,
  description,
  occurrences,
}: GroupedDetailsCellProps) => {
  return (
    <Stack direction={"column"} align={"start"} gap={"md"} className={"al-px-2"}>
      <Stack align={"center"} gap={"sm"} className={"al-w-full"}>
        <Stack gap={"xs"} align={"center"} className={"al-p-1 al-rounded al-bg-[#d5e7ff]"}>
          {getNamedResourceImageByType(getResourceImageType(resource_type))}
        </Stack>
        <div
          className={
            "al-px-1 al-py-1.5 al-gap-2.5 al-rounded al-bg-brand al-text-white al-text-sm al-font-normal"
          }
        >
          {opportunity_name}
        </div>
      </Stack>
      <Stack align={"center"} gap={"sm"} className={"al-w-full al-text-dark-gray"}>
        <div className={"al-w-full al-text-wrap"}>
          <CollapsibleField
            label=""
            text={description}
            defaultLines={2}
            alignCenter={true}
            textStyle=""
          />
        </div>
      </Stack>
      <Stack gap={"lg"} align={"center"}>
        <div
          className={
            "al-rounded-full al-bg-[#ffeae4] al-text-[#ff7064] al-text-xs al-font-medium al-leading-5 al-px-1.5 al-py-0.5"
          }
        >
          <Tooltip title={`This opportunity was linked to ${occurrences} resources.`}>
            <span>Count: {occurrences}</span>
          </Tooltip>
        </div>
      </Stack>
    </Stack>
  );
};
